import { API } from 'aws-amplify'

const loadAllData = async user => {
  // console.log('[fetchData] loadAllData called with user:', user ? user.username : 'no user')
  try {
    // console.log('[fetchData] Making API call to get account data')
    const url = '/account/?email=' + encodeURIComponent(user.username)
    // console.log('[fetchData] API URL:', url)
    
    let response = await API.get('account', url)
    // console.log('[fetchData] API response received:', response)
    
    const accounts = response.items
    // console.log('[fetchData] Processing accounts:', accounts ? accounts.length : 0)
    
    for (const [acctIdx, acct] of accounts.entries()) {
      // console.log(`[fetchData] Processing account ${acctIdx}:`, acct.email)
      for (const [calIdx, cal] of acct.calendars.entries()) {
        // console.log(`[fetchData] Processing calendar ${calIdx}:`, cal.name)
        accounts[acctIdx].calendars[calIdx].calendarAccountId =
          acct.calendarAccountId
        accounts[acctIdx].calendars[calIdx].calendarAccountType =
          acct.calendarAccountType
        accounts[acctIdx].calendars[calIdx].email =
          acct.email
      }
    }
    
    // console.log('[fetchData] Returning processed data')
    // console.log('[fetchData] Syncs:', response.bridges ? response.bridges.length : 0)
    // console.log('[fetchData] Schedules:', response.schedules ? response.schedules.length : 0)
    // console.log('[fetchData] Integrations:', response.integrations ? response.integrations.length : 0)
    // console.log('[fetchData] License:', response.license)
    
    return {
      accounts,
      syncs: response.bridges,
      schedules: response.schedules,
      integrations: response.integrations,
      license: response.license,
    }
  } catch (error) {
    console.error('[fetchData] Error in loadAllData:', error)
    return {
      error,
    }
  }
}

const loadAccounts = async () => {
  // console.log('[fetchData] loadAccounts called')
  try {
    // console.log('[fetchData] Making API call to get accounts with calendars')
    let response = await API.get('account', '/account/?calendars=true')
    // console.log('[fetchData] API response received for accounts:', response)
    
    const accounts = response.items
    // console.log('[fetchData] Processing accounts:', accounts ? accounts.length : 0)
    
    for (const [acctIdx, acct] of accounts.entries()) {
      // console.log(`[fetchData] Processing account ${acctIdx}:`, acct.email)
      for (const [calIdx, cal] of acct.calendars.entries()) {
        // console.log(`[fetchData] Processing calendar ${calIdx}:`, cal.name)
        accounts[acctIdx].calendars[calIdx].calendarAccountId =
          acct.calendarAccountId
        accounts[acctIdx].calendars[calIdx].calendarAccountType =
          acct.calendarAccountType
      }
    }
    
    // console.log('[fetchData] Returning processed accounts')
    return accounts
  } catch (error) {
    console.error('[fetchData] Error in loadAccounts:', error)
    return []
  }
}

const loadSyncs = async () => {
  // console.log('[fetchData] loadSyncs called')
  try {
    // console.log('[fetchData] Making API call to get syncs')
    const response = await API.get('bridge', '/bridge/')
    // console.log('[fetchData] API response received for syncs:', response)
    // console.log('[fetchData] Syncs loaded:', response.items ? response.items.length : 0)
    return response.items
  } catch (error) {
    console.error('[fetchData] Error in loadSyncs:', error)
    return []
  }
}

const loadSchedules = async () => {
  // console.log('[fetchData] loadSchedules called')
  try {
    // console.log('[fetchData] Making API call to get schedules')
    const response = await API.get('schedules', '/schedules')
    // console.log('[fetchData] API response received for schedules:', response)
    // console.log('[fetchData] Schedules loaded:', response.sourceItems ? response.sourceItems.length : 0)
    return response.sourceItems
  } catch (error) {
    console.error('[fetchData] Error in loadSchedules:', error)
    return []
  }
}

export { loadAccounts, loadAllData, loadSchedules, loadSyncs }
